<template>
  <v-container class="notfound-container" fluid>
    <div class="notfound-content elevation-10">
      <v-icon color="primary" size="110" class="mb-4">mdi-emoticon-sad-outline</v-icon>
      <h1 class="notfound-title">404</h1>
      <h2 class="notfound-subtitle">Página não encontrada</h2>
      <p class="notfound-message">
        Opa! A página que você procura não existe ou foi removida.<br>
        Verifique o endereço digitado.
      </p>
    </div>
  </v-container>
</template>

<style scoped>
.notfound-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5fafd 0%, #e3f0ff 100%);
  padding: 0;
}

.notfound-content {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px 0 rgba(25, 118, 210, 0.10);
  padding: 44px 32px 36px 32px;
  text-align: center;
  max-width: 410px;
  width: 100%;
  transition: box-shadow 0.2s;
}

.notfound-title {
  font-size: 4.5rem;
  font-weight: 900;
  color: #1976d2;
  margin: 0;
  letter-spacing: 6px;
  line-height: 1;
}

.notfound-subtitle {
  font-size: 1.7rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
  margin-top: 0.5rem;
  letter-spacing: 1px;
}

.notfound-message {
  color: #5c6bc0;
  font-size: 1.08rem;
  margin-top: 8px;
  margin-bottom: 0;
  line-height: 1.6;
}

.v-btn {
  font-weight: 600;
  letter-spacing: 0.5px;
}
</style>